import { Map, Record } from 'immutable';
import { MutationType, OwnerIdType } from './index.js';
export var MediumState;
(function (MediumState) {
    MediumState["NEW"] = "new";
    MediumState["UPLOADED"] = "uploaded";
    MediumState["PROCESSING"] = "processing";
    MediumState["PROCESSED"] = "processed";
    MediumState["ERRORED"] = "errored";
})(MediumState || (MediumState = {}));
export var MediumType;
(function (MediumType) {
    MediumType["IMAGE"] = "image";
    MediumType["MODEL_3D"] = "model3d";
    MediumType["VIDEO"] = "video";
    MediumType["AUDIO"] = "audio";
    MediumType["DOCUMENT"] = "document";
    MediumType["UNKNOWN"] = "unknown";
})(MediumType || (MediumType = {}));
export var MediaInclusionType;
(function (MediaInclusionType) {
    MediaInclusionType["NONE"] = "none";
    MediaInclusionType["PRIMARY"] = "primary";
    MediaInclusionType["ALL"] = "all";
})(MediaInclusionType || (MediaInclusionType = {}));
export var MediaBasename;
(function (MediaBasename) {
    MediaBasename["UUID"] = "uuid";
    MediaBasename["OBJECTID"] = "objectid";
    MediaBasename["NAME"] = "name";
    MediaBasename["ORIGINAL"] = "original";
})(MediaBasename || (MediaBasename = {}));
export const IMAGE_SIZE_THUMBNAIL = 200;
export const IMAGE_SIZE_SMALL = 768;
export const IMAGE_SIZE_MEDIUM = 992;
export const IMAGE_SIZE_LARGE = 1200;
export const IMAGE_SIZE_MAX = 5000;
export const IMAGE_QUALITY = 80; // ???: Sharp defaults this to 80 ???:
export const FUZZY_IMAGE_QUALITY = 10;
export const FULL_IMAGE_QUALITY = 100;
export const PDF_QUALITY = 75;
export var MediumDensity;
(function (MediumDensity) {
    MediumDensity["DENSITY_1X"] = "1x";
    MediumDensity["DENSITY_2X"] = "2x";
})(MediumDensity || (MediumDensity = {}));
export class MediumDescriptorRecord extends Record({
    muid: '',
    name: undefined,
    description: undefined,
    transform: undefined,
    preview: undefined,
    thumbnail: undefined
}) {
    toJS() {
        return super.toJS();
    }
}
/**
 * DerivativeMediumRecord
 */
export class DerivativeMediumRecord extends Record({
    path: '',
    width: 0,
    height: 0
}) {
    toJS() {
        return super.toJS();
    }
}
/**
 * @deprecated - no longer used.  Remove when no references remain
 */
export const PUBLIC_MEDIA_PROPS = [
    'public_thumbnail',
    'public_thumbnail_2x',
    'public',
    'public_2x',
    'public_highres',
    'public_highres_2x',
    'public_original'
];
export const DIRECT_MEDIA_PATHS = [
    'thumbnail',
    'thumbnail_2x',
    'edit',
    'full',
    'full_sq'
];
export const ONDEMAND_SQUARE_MEDIA_PATHS = [
    'small_sq',
    'small_sq_2x',
    'large_sq',
    'large_sq_2x'
];
export const ONDEMAND_NATURAL_MEDIA_PATHS = [
    'small',
    'large',
    'small_2x',
    'large_2x'
];
export const ONDEMAND_MEDIA_PATHS = [
    ...ONDEMAND_SQUARE_MEDIA_PATHS,
    ...ONDEMAND_NATURAL_MEDIA_PATHS
];
/**
 * @deprecated - no longer used.  Remove when no references remain
 */
export const DERIVATIVE_MEDIA_PATHS = [
    ...DIRECT_MEDIA_PATHS,
    ...ONDEMAND_MEDIA_PATHS
];
export class MediumRecord extends Record({
    uuid: '',
    account_id: undefined,
    entry_uuid: undefined,
    individual_id: undefined,
    owner_id: undefined,
    owner_type: undefined,
    content_type: '',
    original_filename: undefined,
    path: '',
    extent: undefined,
    width: 0,
    height: 0,
    meta_info: undefined,
    name: undefined,
    description: undefined,
    order: 0,
    transform: undefined,
    web_publishing: undefined,
    percent_complete: undefined,
    created_by: undefined,
    created_at: '',
    updated_by: undefined,
    updated_at: '',
    _previewDataURL: undefined,
    _thumbnailDataURL: undefined,
    _info: undefined,
    _meta: undefined,
    _partial: undefined,
    _error: undefined
}) {
    toJS() {
        return super.toJS();
    }
}
//# sourceMappingURL=media.js.map